// @flow
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDollarSign,
  faPiggyBank,
  faUser,
  faUtensils,
  faVideo,
  faTasks,
  faSignal,
  faPhone,
  faGlobe,
  faCheck,
  faTv,
  faStar as faStarSolid,
  faSliders,
  faSearch
} from '@fortawesome/free-solid-svg-icons';
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';

export { default as PlaceOutlined } from '@material-ui/icons/PlaceOutlined';
export { default as EmailOutlined } from '@material-ui/icons/EmailOutlined';
export { default as LinkOutlined } from '@material-ui/icons/LinkOutlined';
export { default as PersonOutlined } from '@material-ui/icons/PersonOutlined';
export { default as PhoneOutlined } from '@material-ui/icons/PhoneOutlined';
export { default as HourglassEmptyOutlined } from '@material-ui/icons/HourglassEmptyOutlined';
export { default as HourglassFullOutlined } from '@material-ui/icons/HourglassFullOutlined';
export { default as WifiOutlined } from '@material-ui/icons/WifiOutlined';
export { default as TvOutlined } from '@material-ui/icons/TvOutlined';
export { default as PetsOutlined } from '@material-ui/icons/PetsOutlined';
export { default as Help } from '@material-ui/icons/Help';
export { default as LocationOffOutlined } from '@material-ui/icons/LocationOffOutlined';
export { default as WatchLaterOutlined } from '@material-ui/icons/WatchLaterOutlined';
export { default as PhoneDisabledOutlined } from '@material-ui/icons/PhoneDisabledOutlined';
export { default as PhoneEnabledOutlined } from '@material-ui/icons/PhoneEnabledOutlined';

const FontAwesomeMap = {
    usd: faDollarSign,
    'piggy-bank': faPiggyBank,
    user: faUser,
    cutlery: faUtensils,
    'hd-video': faVideo,
    tasks: faTasks,
    signal: faSignal,
    phone: faPhone,
    globe: faGlobe,
    ok: faCheck,
    star: faStarSolid,
    tv: faTv,
    'star-empty': faStarRegular,
    sliders: faSliders,
    search: faSearch
  };

export function FAIcon(icon, opts = {}) {
    const { className, style, onClick} = opts; 
    const faIcon = FontAwesomeMap[icon];

    if (!faIcon) {
        console.log(`Icon missing fa icon: "${icon}"`);
        return null;
    }

    return (
        <FontAwesomeIcon
          icon={faIcon}
          className={className}
          style={{ position: 'relative', ...style }}
          aria-hidden="true"
          onClick={onClick}
        />
      );
}